
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { BootModule } from './app/boot/boot.module';
import { environment } from './environments/environment';

import * as hammer from 'hammerjs';

if (['staging', 'production'].includes(environment.environment)) {
  enableProdMode();
}

// tslint:disable: no-string-literal
platformBrowserDynamic().bootstrapModule(BootModule)
  .then(ref => {
    // Ensure Angular destroys itself on hot reloads.
    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = ref;
  })
  .catch(err => console.error(err));
